import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=733ffd68&scoped=true&"
import script from "./ExamList.vue?vue&type=script&lang=ts&"
export * from "./ExamList.vue?vue&type=script&lang=ts&"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=733ffd68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ffd68",
  null
  
)

export default component.exports